import React from "react";
import Homepage from "./pages/Homepage";
import "./Styles.scss";

function App() {
  return (
    <>
      <Homepage />
    </>
  );
}

export default App;
